import React from "react";

import "./socialIcon.css";

const SocialIcon = (props) => {
  return <div className="okiro__socialicon">{props.childIcon}</div>;
};

export default SocialIcon;
